export default [
      //Start CVD
      {
        path: '/',
        name: 'home',
        component: () => import('@/views/documents/list.vue'),
        meta: {
          pageTitle: '',
          requiresAuth: true,
          breadcrumb: [
            {
              text: 'All Documents',
              active: true,
            },
          ],
        },
      },
      {
        path: '/document/view/:id',
        name: 'view-document',
        component: () => import('@/views/documents/detail.vue'),
        meta: {
          pageTitle: '',
          requiresAuth: true,
          breadcrumb: [
            {
              text: 'All Documents',
              active: true,
            },
          ],
        },
      },
      {
        path: '/all-documents',
        name: 'all-documents',
        component: () => import('@/views/documents/list.vue'),
        meta: {
          pageTitle: '',
          requiresAuth: true,
          breadcrumb: [
            {
              text: 'All Documents',
              active: true,
            },
          ],
        },
      },


      {
        path: '/projects/list',
        name: 'projects_list',
        component: () => import('@/views/projects/list.vue'),
        meta: {
          pageTitle: '',
          requiresAuth: true,
          breadcrumb: [
            {
              text: 'All Projects',
              active: true,
            },
          ],
        },
      },
      {
        path: '/project/edit/:id',
        name: 'project_edit',
        component: () => import('@/views/projects/edit.vue'),
        meta: {
          pageTitle: '',
          requiresAuth: true,
          breadcrumb: [
            {
              text: 'Edit Project',
              active: true,
            },
          ],
        },
      },
]